import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/journal/note/note';
import 'Bem/site/bg/bg';
import 'Bem/site/rdc-map/rdc-map';
import 'Bem/site/radio/radio';
import 'Bem/site/filter-formats/filter-formats';
import 'Bem/site/photo-masonry/photo-masonry';
import 'Bem/site/tabs/tabs';
import 'Bem/site/triple-news-slider/triple-news-slider';
import 'Bem/site/faq-accordion/faq-accordion';
import 'Bem/site/meetings/meetings';
import 'Bem/site/form-oprosnik/form-oprosnik';
import 'Bem/site/search-content/search-content';

svgSpriteLoader('/site/partners/svg/sprite.svg?v=20210317');

// Установка активного пункта в табах на странице Франчайзи
const sFilterFormatLink = '.filter-formats__link';
const cFilterFormatLinkActive = 'filter-formats__link_active';

function onToggleTab(e, $tabs, index) {
    const $tabActive = $tabs.find(`.tabs__link${sFilterFormatLink}`).eq(index);
    const name = $tabActive.text();

    $tabs.find(sFilterFormatLink).removeClass(cFilterFormatLinkActive);
    $tabActive.addClass(cFilterFormatLinkActive);
    $tabs.find('.filter-btn__text').text(name);
    $tabs.find('.link-drop-down').trigger('eksmoCallLinkDropDownClose');
}

$('body').on('toggle.tabs.eksmo', onToggleTab);
//